import { css } from "@emotion/css";
export const beforeGroupClass = css({ fontSize: "0.75rem", paddingLeft: 4, fontWeight: "bold" });
